angular.module('myappointments').config(['AppRoutesProvider', '$stateProvider', '$urlRouterProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'forms' };

        var appRoutes = {
            'forms': {
                state: 'forms',
                route: '/forms',
                portalSettings: portalSettings
            },
            'completeForm': {
                state: 'completeforms',
                route: '/complete-form/:relSurveyPatientId?patientId?questionnaireId',
                portalSettings: portalSettings
            },
            'confirmForm': {
                state: 'confirmforms',
                route: '/confirm-form/',
                portalSettings: portalSettings
            },
            'patientQuestionnaire': {
                state: 'patientquestionnaire',
                route: '/patient-questionnaire/:relSurveyPatientId?patientId?questionnaireId',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.forms.state, {
                url: appRoutes.forms.route,
                templateUrl: '/forms/views/forms.html',
                controller: 'FormsCtrl',
                description: '/forms',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Forms'); }
                }
            })
            .state(appRoutes.completeForm.state, {
                url: appRoutes.completeForm.route,
                templateUrl: '/forms/views/completeForm.html',
                controller: 'CompleteFormCtrl',
                description: '/CompleteForm',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Forms'); }
                }
            })
            .state(appRoutes.confirmForm.state, {
                url: appRoutes.confirmForm.route,
                templateUrl: '/forms/views/confirmForm.html',
                controller: 'ConfirmFormCtrl',
                description: '/ConfirmForm',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Forms'); }
                }
            })
            .state(appRoutes.patientQuestionnaire.state, {
                url: appRoutes.patientQuestionnaire.route,
                templateUrl: '/forms/views/patientQuestionnaire.html',
                controller: 'PatientQuestionnaireCtrl',
                description: '/PatientQuestionnaire',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('Forms'); }
                }
            });
    }]);